import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { IconChartPie } from "@tabler/icons-react";
import useInsightsFilters from "./hooks/useInsightsFilters";
import InsightsHeader from "./components/InsightsHeader";
import AIPerformanceBlock from "./components/AIPerformanceBlock";
import GrowthBlock from "./components/GrowthBlock";
import BottlenecksBlock from "./components/BottlenecksBlock";
import TeamBlock from "./components/TeamBlock";
import InsightsHelpModal from "./components/InsightsHelpModal";
import "./styles/insights.css";

const Insights = () => {
  const f = useInsightsFilters();
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <Container fluid className="insights-page py-4">
      <div className="insights-page__title">
        <div className="insights-page__title-icon">
          <IconChartPie size={24} />
        </div>
        <div>
          <h1>Relatórios Avançados</h1>
          <p>Métricas estratégicas pra decidir com clareza</p>
        </div>
      </div>

      <InsightsHeader
        PRESETS={f.PRESETS}
        COMPARE_OPTIONS={f.COMPARE_OPTIONS}
        preset={f.preset}
        applyPreset={f.applyPreset}
        dateStart={f.dateStart}
        dateEnd={f.dateEnd}
        setDateStart={f.setDateStart}
        setDateEnd={f.setDateEnd}
        compareWith={f.compareWith}
        setCompareWith={f.setCompareWith}
        applyCustomDates={f.applyCustomDates}
        isDraftDirty={f.isDraftDirty}
        onOpenHelp={() => setHelpOpen(true)}
      />

      <div className="insights-stack">
        <AIPerformanceBlock filters={f.filters} />
        <GrowthBlock filters={f.filters} />
        <BottlenecksBlock filters={f.filters} />
        <TeamBlock filters={f.filters} />
      </div>

      <InsightsHelpModal show={helpOpen} onHide={() => setHelpOpen(false)} />
    </Container>
  );
};

export default Insights;
